export enum ProjectTempType {
    Project = 1,
    Template = 2
  }

  export enum FormTypes {
    PdfForm = 1,
    TabularForm = 2,
    HtmlForm=3
  }
 
  export enum ProjectTempStep {
    Step0 = 0,
    Step1 = 1,
    Step2 = 2,
    Step3 = 3,
    Step4 = 4,
  }

  export enum FormAuditType {
    NormalForm = 1,
    AuditForm = 2,   
  }

  export enum PlaceholderStatus {
    Empty=0,
    FormSelected=1,
    ProjectCreated=2,
    ProjectSent=3,
    ProjectCompleted=4
  }

  export enum FormOrShared {
    MyForm="MyForm",
    SharedWithMe="SharedWithMe",   
  }
 
  export enum CCCName {
    Core="Core",
    Contact="Contact",
    Company="Company",
    Task="Task",
    NewTask="New Task",
    FileManager="File Manager"
  }

  export enum RoleLevel {
    SuperAdmin=1,
    OrganizationAdmin=2,
    OfficeAdmin=3,
    User=11,
  }
 
  export enum MasterTemplateCategory{
     Save = 1,
     //Modify=2,
     Delete=3, 
    // HardDelete=4,
     Rename=5,
     ChangeStatus=6
    }